import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { SelectInput } from "../SelectInput";

import { Link } from 'react-router-dom';

const required = value => (value == null ? 'Required' : undefined)

class EnterpriseEditForm extends React.Component {

  constructor(props) {
    super(props);

    const initData = {
      'name': props.enterprise.name,
      'owner': {value: props.enterprise.owner.id, label: props.enterprise.owner.name}
    };
    this.props.initialize(initData);
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Error: </strong>{this.props.errorMessage}
      </div>
    }
  }

  render() {
    const {handleSubmit, owners} = this.props

    return (
      <div className="login-form">
        <form onSubmit={handleSubmit}>
          <div className="add-margin-top">
            <label>Enterprise Owner</label>

            <Field
              name='owner'
              component={SelectInput} 
              options={owners.map(owner => ({value: owner.id, label: owner.name, owner: owner}))} 
              onChange={(option) => console.log(option)}
            />
          </div>

          <div className="add-margin-top">
            <label>Enterprise Name</label>

            <Field
              type="text"
              className="form-control"
              name="name"
              component="input"
              validate={required}
              ref="name"
              withRef
            />
          </div>

          <br /> <br />
          
          <button type="submit" className="btn btn-primary btn-block">Save</button>
          
          <br />
          
          <Link to="/admin-admin/enterprises"><button className="btn btn-primary btn-block">Cancel</button></Link>
        </form>
      </div>
    );
  }
}

export default reduxForm({ form: 'EnterpriseEditForm' })(EnterpriseEditForm);
